export const URLS = {
  ORDER_PAGE_DATA: '/store/plans/createOrderPage',
  ORDER_PAGE_DATA_V2: '/store/v2/plans/createOrderPage',
  DYNAMIC_ORDER_PAGE: '/_api/premium-store/v1/createOrderPage',
  VERIFY_DOUBLE_PURCHASE: '/store/verifyPlansDoublePurchase',
  DYNAMIC_VERIFY_DOUBLE_PURCHASE:
    '/_api/premium-store/v1/ValidateNoPreviousPurchase',
  REQUEST_CALL_FORM_SUBMIT: '/premium-purchase-plan/api/v1/requestCall/submit',
  REQUEST_CALL_FORM_SUBMIT_CORVID:
    'https://www.wix.com/premiumhosting/enterprise-report/_functions/API',
  REQUEST_CALL_FORM_SUBMIT_V2:
    '/premium-purchase-plan/api/v2/requestCall/submit',
  CHANGE_PLAN_DETAILS: '/store/changePlan/getChangePlanDetails',
  DYNAMIC_CHANGE_PLAN_DETAILS: '/store/v1/changePlan/getChangePlanDetails',
  SWITCH_AND_EXTEND: '/store/changePlan/switchAndExtend',
  DYNAMIC_SWITCH_AND_EXTEND: '/store/v1/changePlan/switchAndExtend',
  SWITCH_AND_REFUND: '/store/changePlan/switchAndRefund',
  DYNAMIC_SWITCH_AND_REFUND: '/store/v1/changePlan/switchAndRefund',
  SWITCH_IN_GRACE_PERIOD: '/store/changePlan/switchInGracePeriod',
  DYNAMIC_SWITCH_IN_GRACE_PERIOD: '/store/v1/changePlan/switchInGracePeriod',
  PREMIUM_MARKETING_DATA: '/premium-marketing-data',
  GET_PLAN_FEATURES: '/premium-purchase-plan/api/v1/planFeatures',
  GET_SALE_END_DATE: '/_serverless/marketing-data/getSaleEndDate',
  GET_ASSIGNED_DOMAINS: '/_api/my-domains/v1/domains/assigned',
};
